import {
  getFilterReleasedProducts,
  ProductConfigurationFilterType,
} from '@/integrations/algolia/helpers';
import type { StrapHit } from '@/integrations/algolia/types';

export const MATERIAL_EN_FILTERS: Record<
  string,
  { filterMaterial1: string; filterMaterial2?: string }
> = {
  alligator: { filterMaterial1: 'Alligator leather' },
  leather: { filterMaterial1: 'Calfskin leather' },
  fabric: {
    filterMaterial1: 'Polyamide fabric',
    filterMaterial2: 'ECONYL® yarn',
  },
  rubber: { filterMaterial1: 'Rubber' },
  default: { filterMaterial1: '*' },
};

export type StrapLengthLocaleMap = Record<string, string>;
export type StrapMapValue = {
  variant_group: string[];
  variants: Record<string, VariantData>;
};
export type StrapMap = Record<string, StrapMapValue>;
export type VariantData = {
  call_to_action: string;
  strap_length: StrapLengthLocaleMap;
  variant_id: string;
};

const buildBaseMap = (hits: StrapHit[]) => {
  const map: StrapMap = {};
  const seen: Record<string, true> = {};

  hits.forEach(({ objectID, variant_group }) => {
    map[objectID] = { variant_group, variants: {} };
    variant_group?.forEach((id) => (seen[id] = true));
  });

  return { map, variantIds: Object.keys(seen) };
};

const fillStrapLengths = async (
  map: StrapMap,
  variantIds: string[],
  indexName: string,
  draftMode?: boolean,
) => {
  if (!variantIds.length) return;

  const publishedHits = await getFilterReleasedProducts<StrapHit>(
    variantIds,
    '',
    'Strap',
    ProductConfigurationFilterType.PDP,
    indexName,
    false,
    draftMode,
  );

  publishedHits.forEach((r) => {
    if (!r) return;
    Object.values(map).forEach((parent) => {
      if (parent.variant_group?.includes(r.objectID)) {
        parent.variants[r.objectID] = {
          strap_length: r.strap_length,
          call_to_action: r.call_to_action,
          variant_id: r?.variant_id,
        };
      }
    });
  });
};

export const getStrapSizeDatas = async (
  hits: StrapHit[],
  indexName: string,
  draftMode?: boolean,
) => {
  const { map, variantIds } = buildBaseMap(hits);
  await fillStrapLengths(map, variantIds, indexName, draftMode);
  return map;
};
